import React from 'react'
import ProductAhan from '../../Products/ProductAhan'
import { Link } from 'react-router-dom'
import CategoryAhanPageORGFA from '../../Products/CategoryAhanPageORGFA'

function ProductCstegoryAhan() {
  return (
    <>
        <div className='c-Product' >
            <div className='c-titleProduct'>
                <div className='titleProduct'>
                    <h1> دسته بندی آهن </h1>
                    <p> گروه آهن شامل محصولات فلزی مانند تیرآهن، میلگرد، نبشی و پروفیل است که در ساخت‌وساز و صنایع مختلف به کار می‌روند. این محصولات به دلیل استحکام بالا و کاربرد گسترده در سازه‌های فولادی و صنعتی اهمیت دارند </p>
                </div>
            </div>
            
            <div className='c-AllProduct'>
                    <div className='AllProduct-Ahan'>
                        {CategoryAhanPageORGFA.map((item) => {
                            return (
                                <Link to={`product?name=iron&id=${item.CategoryID}`}  key={item.ID}  onClick={() => window.scrollTo(0, 0)}>
                                    <div className="p-Product">
                                        <div className='c-img'> <img  src={item.ImageURL} alt="محصول 1" /> </div>
                                        <h4> {item.Name} </h4>
                                    </div>
                                </Link>
                            )
                        })}
                    </div>
            </div>
        </div>
    </>
  )
}

export default ProductCstegoryAhan